// note_json keys that are internal to BlinkScribe and must never be copied, exported or shown as a
// section (bsfix-name-vocab review 10-19). BlinkScribe already strips them from every client read of
// note_json (order_suggestions.CLIENT_HIDDEN_KEYS); this is the care-side backstop for "Copy all" and
// any other text export that walks every note_json key.
//   name_corrections        known-name corrections audit (Note Review chip reads the row's own field)
//   suggested_orders_detail order type / explicitness tier per suggested order (shadow data)
//   order_suggestions_v2    order suggestions v2 payload (CareIQ order zone only, via its own GET)
export const CLIENT_HIDDEN_NOTE_KEYS = new Set(["name_corrections", "suggested_orders_detail", "order_suggestions_v2"]);

export const isHiddenNoteKey = (key) => CLIENT_HIDDEN_NOTE_KEYS.has(key);
